export function openOverlay(config) {
    return function(dispatch) {
        dispatch({
            type: 'OVERLAY_OPEN',
            config,
        });
    };
}

export function closeOverlay(id) {
    return function(dispatch) {
        dispatch({
            type: 'OVERLAY_CLOSE',
            id,
        });
    };
}

export function closeAllOverlays() {
    return function(dispatch) {
        dispatch({
            type: 'OVERLAY_CLOSE_ALL',
        });
    };
}
